import { X } from 'lucide-react'
import { Button } from '@/clientWeb/components/ui/button'

interface WebinarStartBannerProps {
  show: boolean
  onStart: () => void
  onDismiss: () => void
}

export function WebinarStartBanner({ show, onStart, onDismiss }: WebinarStartBannerProps) {
  return (
    <div
      className={`
        absolute top-20 w-full left-1/2 -translate-x-1/2 z-50
        bg-vc-surface text-vc-text justify-between px-5 py-3.5 rounded-xl shadow-2xl
        flex items-center gap-4 max-w-2xl border border-stroke-100/20
        transition-all duration-500 ease-in-out
        ${show
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 translate-y-4 scale-95 pointer-events-none'
        }
      `}
    >
      <div className="flex items-center gap-2">
        <div className="relative">
          <svg className="animate-spin h-6 w-6 text-cyan-400" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
        </div>

        <span className="text-xs text-white/90">
          <span className="hidden sm:inline text-[14px]">
            Attendees are waiting to join webinar, when you are ready click on start
          </span>
          <span className="sm:hidden">Attendees waiting. Ready to start?</span>
        </span>
      </div>
      <div className="flex gap-2">
        <Button variant="default" type="button" onClick={onStart}>
          START
        </Button>

        <button
          type="button"
          onClick={onDismiss}
          className="cursor-pointer w-8 flex justify-center items-center h-8 text-white/50 hover:text-white hover:bg-card/10 rounded-full p-1.5 transition-all duration-200"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
